module.exports = __webpack_public_path__ + "static/media/laxmirajB.5ba653d2.png";